var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 36,
    fill: "#F34F66",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9757 29.6207C34.4939 28.2789 36.8635 26.9984 40.4992 26.9984C44.5205 26.9984 47.175 28.5811 48.844 30.429C50.582 32.3533 51.227 34.5323 51.227 35.5831C51.227 36.5772 52.0329 37.3831 53.027 37.3831C54.088 37.3831 55.6945 37.7915 56.9978 38.7732C58.2309 39.702 59.1992 41.1378 59.1992 43.3715C59.1992 46.6982 57.569 48.4977 55.6854 49.4671C54.8015 49.922 54.4537 51.0074 54.9086 51.8913C55.3635 52.7752 56.4489 53.123 57.3328 52.6681C60.2578 51.1628 62.7992 48.2153 62.7992 43.3715C62.7992 39.8936 61.205 37.4352 59.1638 35.8977C57.7423 34.827 56.1084 34.2008 54.6377 33.9348C54.2417 32.0879 53.2186 29.9016 51.5156 28.016C49.1984 25.4504 45.589 23.3984 40.4992 23.3984C35.915 23.3984 32.7132 25.0482 30.5916 26.9232C29.8468 27.5816 29.7766 28.7191 30.435 29.464C31.0933 30.2089 32.2308 30.279 32.9757 29.6207ZM27.4669 34.2118C24.8773 35.2273 21.7992 37.7445 21.7992 42.3331C21.7992 45.8993 23.2186 47.7983 24.8435 48.8848C26.5812 50.0468 28.7513 50.3984 30.2492 50.3984H43.6536L27.4669 34.2118ZM47.2536 53.9984H30.2492C28.3304 53.9984 25.3755 53.5712 22.8424 51.8774C20.1965 50.1082 18.1992 47.0745 18.1992 42.3331C18.1992 36.616 21.5836 33.2096 24.7645 31.5093L22.272 29.0168C21.5691 28.3139 21.5691 27.1742 22.272 26.4712C22.975 25.7683 24.1147 25.7683 24.8176 26.4712L51.9705 53.6241C52.6734 54.3271 52.6734 55.4668 51.9705 56.1697C51.2676 56.8727 50.1279 56.8727 49.4249 56.1697L47.2536 53.9984Z",
    fill: "#F5314D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError500);
export default __webpack_public_path__ + "static/media/error-500.10c064c7a3aa786b3a7740b1e6d6fdba.svg";
export { ForwardRef as ReactComponent };